import { render, staticRenderFns } from "./OrderContainer.vue?vue&type=template&id=609a0be4&scoped=true"
import script from "./OrderContainer.vue?vue&type=script&lang=js"
export * from "./OrderContainer.vue?vue&type=script&lang=js"
import style0 from "./OrderContainer.vue?vue&type=style&index=0&id=609a0be4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a0be4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609a0be4')) {
      api.createRecord('609a0be4', component.options)
    } else {
      api.reload('609a0be4', component.options)
    }
    module.hot.accept("./OrderContainer.vue?vue&type=template&id=609a0be4&scoped=true", function () {
      api.rerender('609a0be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/OrderContainer.vue"
export default component.exports